import React, {Component} from "react";
import DepositModal from "./DepositModal";

class AmountSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDepositModalOpen:false,
            depositType:''
        };
    }

    hideOrShowDepositModal = (refresh) =>{
        this.setState({isDepositModalOpen:!this.state.isDepositModalOpen})
        if(refresh)
            this.props.refreshData()
    }

    handleDepositModal = (type) =>{
        this.setState({depositType:type})
        this.hideOrShowDepositModal()
    }

    render() {
        const { query_params, totalCollectedAmount, totalDepositAmount, totalDeoAmount } = this.props;

        return (
            <div>
            <table className="table table-bordered">
                <thead>
                <tr>
                    <th className="text-center">Total collected amount</th>
                    <th className="text-center">Total Deposited Amount</th>
                    <th className="text-center">Total Due Amount</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="text-center">
                        <div style={{marginBottom:'5px'}}>{totalCollectedAmount || 0}</div>
                    </td>
                    <td className="text-center">
                        <div style={{marginBottom:'5px'}}>{totalDepositAmount || 0}</div>
                    </td>
                    <td className="text-center">
                        <div style={{marginBottom:'5px'}}>{totalDeoAmount || 0}</div>
                        <div>
                            <button className="btn btn-sm btn-outline-success"
                                    disabled={totalDeoAmount <= 0} onClick={()=>this.handleDepositModal('due_amount')}>Deposit
                            </button>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <DepositModal 
                handleClose={this.hideOrShowDepositModal} 
                show={this.state.isDepositModalOpen} 
                amount={totalDeoAmount}
                query_params={query_params}
                />
            </div>
        );
    }
}

export default AmountSummary;
